export type Lang = 'cs' | 'en' | 'de'

export const LANGS: { code: Lang; label: string }[] = [
  { code: 'cs', label: 'CZ' },
  { code: 'en', label: 'EN' },
  { code: 'de', label: 'DE' },
]

const cs = {
  nav: {
    home: 'Domů',
    services: 'Služby',
    events: 'Akce',
    pilots: 'Pro piloty',
    briefing: 'Briefing',
    contact: 'Kontakt',
    language: 'Jazyk',
  },
  hero: {
    name: 'Letiště Hořovice',
    tagline: 'Neveřejné vnitrostátní letiště',
    photoAlt: 'Letiště Hořovice',
  },
  meteo: {
    title: 'Meteo',
    temp: 'Teplota',
    dew: 'Rosný bod',
    humidity: 'Vlhkost',
    wind: 'Vítr',
    gust: 'Nárazy',
    dir: 'Směr',
    dawn: 'Úsvit',
    dusk: 'Soumrak',
    unavailable: 'meteo nedostupné',
  },
  stats: {
    elevation: 'Nadmořská výška (370 m)',
    runway: 'Dráha 06/24 (Asfalt)',
    radio: 'Hořovice Radio',
    icao: 'ICAO kód',
  },
  services: {
    title: 'Naše služby',
    items: [
      {
        title: 'Palivo',
        description:
          'BA 95 dostupný u čerpací stanice 200 m od letiště. AVGAS není na letišti k dispozici. Olej TOTAL AERO 100.',
      },
      {
        title: 'Hangárování',
        description:
          'Omezená kapacita pro cizí letadla. Nutno předem projednat s Aviatickým klubem Tlustice.',
      },
      {
        title: 'Výsadková činnost',
        description:
          'Letiště je využíváno pro sportovní parašutismus. Dbejte zvýšené opatrnosti při příletu.',
      },
      {
        title: 'Letecká škola',
        description:
          'Výcvikové lety jiných provozovatelů pouze s písemným souhlasem vedoucího letového provozu.',
      },
      {
        title: 'Ubytování',
        description:
          'Ubytovací možnosti v omezeném rozsahu pouze po předchozím projednání s provozovatelem.',
      },
      {
        title: 'Meteorologické údaje',
        description:
          'Vlastní měření tlaku, větru a dohlednosti na stanovišti RADIO. Data z ČHMÚ Praha-Ruzyně.',
      },
    ],
  },
  events: {
    title: 'Nadcházející akce',
    subtitle: 'Přijďte na letiště na tyto speciální akce.',
    statusPlanned: 'Připravujeme',
    statusDone: 'Úspěšně proběhlo',
    fallback: [
      {
        title: 'Jarní školení',
        description:
          'Každoroční setkání pilotů a lidí napojených na dění kolem letiště Hořovice.',
        type: 'Vzdělávání',
      },
      {
        title: 'Seskoky padákem',
        description:
          '0900 až 1700 CET Seskoky padákem včetně tandemových seskoků. Možnost objednání zážitkových poukazů.',
        type: 'Parašutismus',
      },
      {
        title: 'Ukázka letadel pro nemocné děti',
        description:
          'Dětský den s ukázkou letecké techniky na letišti Hořovice pro děti z místní nemocnice.',
        type: 'Zábava',
      },
    ],
  },
  pilot: {
    title: 'Informace pro piloty',
    subtitle:
      'Základní údaje z Letištního řádu. Vždy si před letem ověřte aktuální AIP a NOTAMy.',
    vfrManual: 'VFR příručka',
    tabs: {
      frequencies: 'Frekvence',
      circuits: 'Okruhy a dráha',
      fees: 'Poplatky',
      arrivalForm: 'Příletový formulář',
      info: 'Další info',
    },
    freq: {
      title: 'Radiové frekvence',
      station: 'Stanice',
      callsign: 'Volací znak',
      frequency: 'Frekvence',
      emergency: 'Nouzová',
      general: 'Obecná',
      prague: 'Praha',
      noteLabel: 'Poznámka:',
      note: 'Provozní doba RADIO není pevně stanovena (O/R). Přílety bez rádia pouze po předchozí domluvě.',
    },
    runway: {
      title: 'Dráhový systém',
      surface: 'ASFALT',
      dimensions: 'Rozměry',
      strength: 'Únosnost',
      slope: 'Sklon',
      slopeNote: '(stoupá k RWY 24)',
      warning: 'Pozor: Posunuté prahy na obou drahách!',
      mapAlt: 'ADC mapa letiště LKHV',
    },
    circuits: {
      title: 'Okruhy',
      northOnly: 'Pouze SEVERNÍ okruhy',
      northOnlyRest: 'pro všechna letadla.',
      turnNote: 'RWY 06 točte DOLEVA, RWY 24 točte DOPRAVA.',
      altitudeLabel: 'Výška okruhu:',
      altitudeNote: 'Minimální výška 1. a 4. zatáčky: 1575 ft AMSL.',
    },
    noise: {
      title: 'Omezení hluku a přeletů',
      items: [
        'Zákaz opakovaných nízkých průletů a postupů nezdařeného přistání (hluková zátěž obce Tlustice).',
        'Po vzletu z RWY 24 se vyhněte doleva obci Záluží.',
        'Po vzletu z RWY 06 se vyhněte doleva obcím Kotopeky a Praskolesy.',
        'Pozor na modelářskou činnost jižně od prahu dráhy 24.',
      ],
    },
    fees: {
      title: 'Poplatky',
      landing: 'Přistávací poplatky',
      ultralight: 'Ultralehká letadla (do 600 kg MTOW)',
      upTo2000: 'Letadla do 2000 kg MTOW',
      over2000: 'Nad 2000 kg MTOW',
      other: 'Ostatní',
      parking: 'Parkování (za den)',
      unauthorized: 'Neoprávněné přistání',
      from: 'od',
      note: 'Poplatky lze uhradit pomocí QR kódů umístěných v blízkosti stanoviště RADIO.',
    },
    info: {
      title: 'Doplňující informace',
      atzTitle: 'ATZ zóna',
      atzHorizontal: 'Horizontálně: Kruh o poloměru',
      atzFromArp: 'od ARP.',
      atzVertical: 'Vertikálně: GND do',
      atzNote:
        'Pozor na TMA II Praha (spodní hranice 3500 ft AMSL) v SV části a prostor LKTSA-7 v JV části.',
      alternatesTitle: 'Náhradní letiště',
      altimeterTitle: 'Kontrolní bod výškoměrů',
      altimeterText: 'Odbavovací plocha před hangárem aeroklubu:',
    },
  },
  contact: {
    title: 'Kontakt',
    address: 'Adresa',
    phone: 'Telefon (RADIO)',
    email: 'E-mail',
    hours: 'Provozní doba',
    hoursValue: 'Nestanovena pevně (O/R)',
    hoursNote: 'Pouze po dohodě s provozovatelem',
    mapTitle: 'Interaktivní mapa',
    mapNote: 'Klikněte pro otevření navigace',
  },
  footer: {
    about: 'Neveřejné vnitrostátní letiště provozované',
    operator: 'Aviatickým klubem Tlustice.',
    quickLinks: 'Rychlé odkazy',
    aboutLink: 'O letišti',
    rights: '© 2026 LKHV Letiště Hořovice. Všechna práva vyhrazena.',
    privacy: 'Ochrana soukromí',
  },
  briefing: {
    title: 'Briefing',
    subtitle: 'Letiště Hořovice — LKHV',
    intro1:
      'Vážení piloti, pro svou činnost na letišti Hořovice - LKHV se nejprve pečlivě seznamte se všemi informacemi na této stránce. Použitím letiště Hořovice potvrzujete, že jste s informacemi na této stránce',
    intro2: 'seznámeni.',
    documents: 'Dokumenty',
    pdf: 'PDF dokument',
    winter: 'Periodické zimní školení AD LKHV — 2026',
    accidents: 'Rozbor leteckých nehod',
    seminar: 'Seminář všeobecného letectví 2026',
    noteCzech: 'Dokumenty jsou k dispozici pouze v češtině.',
  },
}

const en: typeof cs = {
  nav: {
    home: 'Home',
    services: 'Services',
    events: 'Events',
    pilots: 'For pilots',
    briefing: 'Briefing',
    contact: 'Contact',
    language: 'Language',
  },
  hero: {
    name: 'Hořovice Airfield',
    tagline: 'Private domestic airfield',
    photoAlt: 'Hořovice Airfield',
  },
  meteo: {
    title: 'Meteo',
    temp: 'Temperature',
    dew: 'Dew point',
    humidity: 'Humidity',
    wind: 'Wind',
    gust: 'Gusts',
    dir: 'Direction',
    dawn: 'Dawn',
    dusk: 'Dusk',
    unavailable: 'meteo unavailable',
  },
  stats: {
    elevation: 'Elevation (370 m)',
    runway: 'Runway 06/24 (Asphalt)',
    radio: 'Hořovice Radio',
    icao: 'ICAO code',
  },
  services: {
    title: 'Our services',
    items: [
      {
        title: 'Fuel',
        description:
          'MOGAS 95 available at a filling station 200 m from the airfield. AVGAS is not available on site. TOTAL AERO 100 oil.',
      },
      {
        title: 'Hangarage',
        description:
          'Limited capacity for visiting aircraft. Must be arranged in advance with Aviatický klub Tlustice.',
      },
      {
        title: 'Parachuting',
        description:
          'The airfield is used for sport parachuting. Exercise increased caution on arrival.',
      },
      {
        title: 'Flight school',
        description:
          'Training flights by other operators only with written approval of the head of flight operations.',
      },
      {
        title: 'Accommodation',
        description:
          'Limited accommodation available only by prior arrangement with the operator.',
      },
      {
        title: 'Weather data',
        description:
          'Own measurement of pressure, wind and visibility at the RADIO station. Data from CHMI Prague-Ruzyně.',
      },
    ],
  },
  events: {
    title: 'Upcoming events',
    subtitle: 'Join us at the airfield for these special events.',
    statusPlanned: 'Upcoming',
    statusDone: 'Successfully held',
    fallback: [
      {
        title: 'Spring training',
        description:
          'Annual gathering of pilots and people involved in life around Hořovice Airfield.',
        type: 'Training',
      },
      {
        title: 'Parachute jumps',
        description:
          '0900 to 1700 CET parachute jumps including tandem jumps. Experience vouchers available.',
        type: 'Parachuting',
      },
      {
        title: 'Aircraft display for sick children',
        description:
          'A children’s day with an aviation technology display at Hořovice Airfield for children from the local hospital.',
        type: 'Fun',
      },
    ],
  },
  pilot: {
    title: 'Information for pilots',
    subtitle:
      'Key data from the Airfield Manual. Always check current AIP and NOTAMs before flight.',
    vfrManual: 'VFR Manual',
    tabs: {
      frequencies: 'Frequencies',
      circuits: 'Circuits & runway',
      fees: 'Fees',
      arrivalForm: 'Arrival form',
      info: 'More info',
    },
    freq: {
      title: 'Radio frequencies',
      station: 'Station',
      callsign: 'Callsign',
      frequency: 'Frequency',
      emergency: 'Emergency',
      general: 'General',
      prague: 'Prague',
      noteLabel: 'Note:',
      note: 'RADIO operating hours are not fixed (O/R). Arrivals without radio only by prior arrangement.',
    },
    runway: {
      title: 'Runway system',
      surface: 'ASPHALT',
      dimensions: 'Dimensions',
      strength: 'Strength',
      slope: 'Slope',
      slopeNote: '(rising towards RWY 24)',
      warning: 'Caution: Displaced thresholds on both runways!',
      mapAlt: 'LKHV aerodrome chart (ADC)',
    },
    circuits: {
      title: 'Circuits',
      northOnly: 'NORTHERN circuits only',
      northOnlyRest: 'for all aircraft.',
      turnNote: 'RWY 06 turn LEFT, RWY 24 turn RIGHT.',
      altitudeLabel: 'Circuit altitude:',
      altitudeNote: 'Minimum altitude for 1st and 4th turn: 1575 ft AMSL.',
    },
    noise: {
      title: 'Noise and overflight restrictions',
      items: [
        'Repeated low passes and go-around procedures are prohibited (noise impact on the village of Tlustice).',
        'After take-off from RWY 24, avoid the village of Záluží to the left.',
        'After take-off from RWY 06, avoid the villages of Kotopeky and Praskolesy to the left.',
        'Beware of model aircraft activity south of the RWY 24 threshold.',
      ],
    },
    fees: {
      title: 'Fees',
      landing: 'Landing fees',
      ultralight: 'Ultralight aircraft (up to 600 kg MTOW)',
      upTo2000: 'Aircraft up to 2000 kg MTOW',
      over2000: 'Above 2000 kg MTOW',
      other: 'Other',
      parking: 'Parking (per day)',
      unauthorized: 'Unauthorised landing',
      from: 'from',
      note: 'Fees can be paid using the QR codes located near the RADIO station.',
    },
    info: {
      title: 'Additional information',
      atzTitle: 'ATZ zone',
      atzHorizontal: 'Horizontally: circle with a radius of',
      atzFromArp: 'from ARP.',
      atzVertical: 'Vertically: GND up to',
      atzNote:
        'Beware of TMA II Prague (lower limit 3500 ft AMSL) in the NE part and the LKTSA-7 area in the SE part.',
      alternatesTitle: 'Alternate airfields',
      altimeterTitle: 'Altimeter check point',
      altimeterText: 'Apron in front of the aeroclub hangar:',
    },
  },
  contact: {
    title: 'Contact',
    address: 'Address',
    phone: 'Phone (RADIO)',
    email: 'E-mail',
    hours: 'Operating hours',
    hoursValue: 'Not fixed (O/R)',
    hoursNote: 'Only by arrangement with the operator',
    mapTitle: 'Interactive map',
    mapNote: 'Click to open navigation',
  },
  footer: {
    about: 'Private domestic airfield operated by',
    operator: 'Aviatický klub Tlustice.',
    quickLinks: 'Quick links',
    aboutLink: 'About the airfield',
    rights: '© 2026 LKHV Hořovice Airfield. All rights reserved.',
    privacy: 'Privacy policy',
  },
  briefing: {
    title: 'Briefing',
    subtitle: 'Hořovice Airfield — LKHV',
    intro1:
      'Dear pilots, before operating at Hořovice Airfield - LKHV, please carefully review all information on this page. By using Hořovice Airfield you confirm that you are familiar with the information on this page',
    intro2: '.',
    documents: 'Documents',
    pdf: 'PDF document',
    winter: 'Periodic winter training AD LKHV — 2026',
    accidents: 'Aviation accident analysis',
    seminar: 'General Aviation Seminar 2026',
    noteCzech: 'The documents are available in Czech only.',
  },
}

const de: typeof cs = {
  nav: {
    home: 'Start',
    services: 'Leistungen',
    events: 'Termine',
    pilots: 'Für Piloten',
    briefing: 'Briefing',
    contact: 'Kontakt',
    language: 'Sprache',
  },
  hero: {
    name: 'Flugplatz Hořovice',
    tagline: 'Nicht öffentlicher Inlandsflugplatz',
    photoAlt: 'Flugplatz Hořovice',
  },
  meteo: {
    title: 'Meteo',
    temp: 'Temperatur',
    dew: 'Taupunkt',
    humidity: 'Luftfeuchte',
    wind: 'Wind',
    gust: 'Böen',
    dir: 'Richtung',
    dawn: 'Dämmerung',
    dusk: 'Abenddämmerung',
    unavailable: 'Meteo nicht verfügbar',
  },
  stats: {
    elevation: 'Höhe über NN (370 m)',
    runway: 'Bahn 06/24 (Asphalt)',
    radio: 'Hořovice Radio',
    icao: 'ICAO-Code',
  },
  services: {
    title: 'Unsere Leistungen',
    items: [
      {
        title: 'Kraftstoff',
        description:
          'MOGAS 95 an einer Tankstelle 200 m vom Flugplatz erhältlich. AVGAS ist am Platz nicht verfügbar. Öl TOTAL AERO 100.',
      },
      {
        title: 'Hallenunterbringung',
        description:
          'Begrenzte Kapazität für Gastflugzeuge. Vorab mit dem Aviatický klub Tlustice abzustimmen.',
      },
      {
        title: 'Fallschirmsprungbetrieb',
        description:
          'Der Flugplatz wird für den Fallschirmsport genutzt. Beim Anflug erhöhte Vorsicht walten lassen.',
      },
      {
        title: 'Flugschule',
        description:
          'Schulungsflüge anderer Betreiber nur mit schriftlicher Zustimmung des Flugbetriebsleiters.',
      },
      {
        title: 'Unterkunft',
        description:
          'Unterkunft in begrenztem Umfang nur nach vorheriger Absprache mit dem Betreiber.',
      },
      {
        title: 'Wetterdaten',
        description:
          'Eigene Messung von Druck, Wind und Sichtweite an der RADIO-Station. Daten des CHMI Prag-Ruzyně.',
      },
    ],
  },
  events: {
    title: 'Kommende Veranstaltungen',
    subtitle: 'Besuchen Sie diese besonderen Veranstaltungen am Flugplatz.',
    statusPlanned: 'In Vorbereitung',
    statusDone: 'Erfolgreich stattgefunden',
    fallback: [
      {
        title: 'Frühjahrsschulung',
        description:
          'Jährliches Treffen der Piloten und aller, die mit dem Flugplatz Hořovice verbunden sind.',
        type: 'Schulung',
      },
      {
        title: 'Fallschirmsprünge',
        description:
          '0900 bis 1700 CET Fallschirmsprünge einschließlich Tandemsprünge. Erlebnisgutscheine möglich.',
        type: 'Fallschirmsport',
      },
      {
        title: 'Flugzeugschau für kranke Kinder',
        description:
          'Kindertag mit Vorführung von Luftfahrttechnik am Flugplatz Hořovice für Kinder des örtlichen Krankenhauses.',
        type: 'Unterhaltung',
      },
    ],
  },
  pilot: {
    title: 'Informationen für Piloten',
    subtitle:
      'Grunddaten aus der Flugplatzordnung. Prüfen Sie vor dem Flug stets aktuelle AIP und NOTAMs.',
    vfrManual: 'VFR-Handbuch',
    tabs: {
      frequencies: 'Frequenzen',
      circuits: 'Platzrunden & Bahn',
      fees: 'Gebühren',
      arrivalForm: 'Anmeldeformular',
      info: 'Weitere Infos',
    },
    freq: {
      title: 'Funkfrequenzen',
      station: 'Station',
      callsign: 'Rufzeichen',
      frequency: 'Frequenz',
      emergency: 'Notfrequenz',
      general: 'Allgemein',
      prague: 'Prag',
      noteLabel: 'Hinweis:',
      note: 'Die Betriebszeiten von RADIO sind nicht festgelegt (O/R). Anflüge ohne Funk nur nach vorheriger Absprache.',
    },
    runway: {
      title: 'Bahnsystem',
      surface: 'ASPHALT',
      dimensions: 'Abmessungen',
      strength: 'Tragfähigkeit',
      slope: 'Neigung',
      slopeNote: '(steigend Richtung RWY 24)',
      warning: 'Achtung: Versetzte Schwellen an beiden Bahnen!',
      mapAlt: 'ADC-Karte des Flugplatzes LKHV',
    },
    circuits: {
      title: 'Platzrunden',
      northOnly: 'Nur NÖRDLICHE Platzrunden',
      northOnlyRest: 'für alle Luftfahrzeuge.',
      turnNote: 'RWY 06 LINKS drehen, RWY 24 RECHTS drehen.',
      altitudeLabel: 'Platzrundenhöhe:',
      altitudeNote: 'Mindesthöhe der 1. und 4. Kurve: 1575 ft AMSL.',
    },
    noise: {
      title: 'Lärm- und Überflugbeschränkungen',
      items: [
        'Wiederholte Tiefflüge und Durchstartverfahren sind verboten (Lärmbelastung der Gemeinde Tlustice).',
        'Nach dem Start von RWY 24 die Gemeinde Záluží links vermeiden.',
        'Nach dem Start von RWY 06 die Gemeinden Kotopeky und Praskolesy links vermeiden.',
        'Achtung auf Modellflugbetrieb südlich der Schwelle 24.',
      ],
    },
    fees: {
      title: 'Gebühren',
      landing: 'Landegebühren',
      ultralight: 'Ultraleichtflugzeuge (bis 600 kg MTOW)',
      upTo2000: 'Flugzeuge bis 2000 kg MTOW',
      over2000: 'Über 2000 kg MTOW',
      other: 'Sonstiges',
      parking: 'Parken (pro Tag)',
      unauthorized: 'Unberechtigte Landung',
      from: 'ab',
      note: 'Die Gebühren können über die QR-Codes in der Nähe der RADIO-Station bezahlt werden.',
    },
    info: {
      title: 'Ergänzende Informationen',
      atzTitle: 'ATZ-Zone',
      atzHorizontal: 'Horizontal: Kreis mit Radius',
      atzFromArp: 'um den ARP.',
      atzVertical: 'Vertikal: GND bis',
      atzNote:
        'Achtung auf TMA II Prag (Untergrenze 3500 ft AMSL) im NO-Teil und den Bereich LKTSA-7 im SO-Teil.',
      alternatesTitle: 'Ausweichflugplätze',
      altimeterTitle: 'Höhenmesser-Kontrollpunkt',
      altimeterText: 'Vorfeld vor der Halle des Aeroclubs:',
    },
  },
  contact: {
    title: 'Kontakt',
    address: 'Adresse',
    phone: 'Telefon (RADIO)',
    email: 'E-Mail',
    hours: 'Betriebszeiten',
    hoursValue: 'Nicht fest geregelt (O/R)',
    hoursNote: 'Nur nach Absprache mit dem Betreiber',
    mapTitle: 'Interaktive Karte',
    mapNote: 'Zum Öffnen der Navigation klicken',
  },
  footer: {
    about: 'Nicht öffentlicher Inlandsflugplatz, betrieben vom',
    operator: 'Aviatický klub Tlustice.',
    quickLinks: 'Schnelllinks',
    aboutLink: 'Über den Flugplatz',
    rights: '© 2026 LKHV Flugplatz Hořovice. Alle Rechte vorbehalten.',
    privacy: 'Datenschutz',
  },
  briefing: {
    title: 'Briefing',
    subtitle: 'Flugplatz Hořovice — LKHV',
    intro1:
      'Liebe Piloten, machen Sie sich vor dem Betrieb am Flugplatz Hořovice - LKHV sorgfältig mit allen Informationen auf dieser Seite vertraut. Mit der Nutzung des Flugplatzes Hořovice bestätigen Sie, dass Sie die Informationen auf dieser Seite',
    intro2: 'kennen.',
    documents: 'Dokumente',
    pdf: 'PDF-Dokument',
    winter: 'Periodische Winterschulung AD LKHV — 2026',
    accidents: 'Analyse von Flugunfällen',
    seminar: 'Seminar der Allgemeinen Luftfahrt 2026',
    noteCzech: 'Die Dokumente sind nur auf Tschechisch verfügbar.',
  },
}

export const translations: Record<Lang, typeof cs> = { cs, en, de }

export type Translation = typeof cs
